import { j as json } from "../../../../../chunks/index2.js";
import { f as findCustomerByEmail, g as getLatestPaymentIntent } from "../../../../../chunks/stripe.js";
import { h as handleRequest } from "../../../../../chunks/utils2.js";
import { b as sendLicenseVerifiedEmail } from "../../../../../chunks/mailer.js";
import admin from "firebase-admin";
const GET = handleRequest(async ({ url, locals, fetch }) => {
  const { searchParams } = url;
  const email = searchParams.get("email");
  if (email) {
    const customer = await findCustomerByEmail(email);
    const paymentIntent = await getLatestPaymentIntent(customer.id);
    const success = paymentIntent.status === "succeeded";
    if (success) {
      await sendLicenseVerifiedEmail(email);
      await admin.firestore().collection("users").doc(locals.user?.id).set(
        { license: "premium", trialAvailability: false, trialStartDate: null },
        { merge: true }
      );
    }
    return json(
      {
        success
      },
      {
        status: success ? 200 : 403
      }
    );
  }
  return json({ error: "No email provided" }, { status: 400 });
});
export {
  GET
};
